import React, { useEffect, useState } from "react";
import axios from "axios";
import port from "../img/portfolio.jpg";
import "../Portfolio/Portfolio.css";
import "./Service.css";
import { motion, useScroll, useTransform } from "framer-motion";

function Service() {
  const [servicePage, setServicePage] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/services`,
          { withCredentials: true }
        );
        setServicePage(response.data);
      } catch (error) {
        console.error("Error fetching service data:", error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="portfolio-section">
      <div className="portfolio-container">
        <img src={port} alt="portfolio background" />
        <div className="portfolio-hero-text">
          "Blending Realities. Building Experiences."
        </div>
      </div>

      <div className="service-page-home-background">
      <div className="sticky-scroll-section-service">
        {servicePage.map((service, index) => (
          <ScrollService key={index} service={service} index={index} />
        ))}
      </div>
    </div>
    </div>
  );
}

function ScrollService({ service, index }) {
  const { scrollYProgress } = useScroll({
    target: undefined,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, 0]); 
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.div
      className="service-page-card"
      style={{
        zIndex: service.length - index, 
      }}
         >
      <div className="service-left-content">
        <div className="service-left-content-header">{service.title}</div>
        <div className="service-left-content-para">{service.description}</div>
      </div>
      <motion.div className="service-right-content" >
        <img src={service.image} alt={service.title} />
      </motion.div>
    </motion.div>
  );
}

export default Service;
